export default {"src":"/pro/_next/static/media/uni.b4fdbf8b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};